import {useEffect,useState} from 'react'
import {useSelector} from 'react-redux'
import Button from 'react-bootstrap/Button'
import {envAwarePost} from '../../util/util'
import useCurrentUser from '../../hooks/useCurrentUser'
import {Link} from 'react-router-dom'


const BeginAcceptingPayments = ()=>{
	const [requiresPhone,setRequiresPhone] = useState(false)
	const [paymentLink,setPaymentLink] = useState('')

	const user = useCurrentUser()

	const pageTypeText = (
		user.account_type === 'gym' 
		? 'Gym' 
		: 'trainer'
	)

	const address = useSelector(
		state => state.users.current_user.bio_data.pageAddress
	)

	useEffect(()=>{
		envAwarePost(
			'api/financials/',
			{ action: "createStripeExpressAccount" }
		).then( res => {
			console.log(res)
			setPaymentLink(res.data.link)
		})
	},[])
	
	const getLinkComponent = ()=>{
		return (
			<div>
				<a href={paymentLink} target="_blank">
					<Button className="mb-2">
						Begin Accepting Payments
					</Button>
				</a>
				<p>
					<small> Allow your clients to pay you directly and you keep all of it, minus a
						<a href="/processingFees" target="_blank"> small processing fee. </a>
					</small>
				</p>
			</div>
		)
	}
	
	return (
		<div className="p-5">
			{getLinkComponent()}
			<h1>What Can You Do With Financials?</h1>
			<h2>Simplify Collecting Payments from Clients</h2>
			<p>
				VIP.Coach allows you to collect payments from existing clients and new clients on your {pageTypeText} Page: <a target="_blank" href={address}>View Your {pageTypeText} Page</a>.  New clients can purchase directly from your {pageTypeText} Page.  Upon successful payment, if the client does not yet have a VIP.Coach account, a new client account will automatically be added to your client list under the email and name they used when purchasing. Configure the system to also automatically send custom welcome emails complete with login instructions.
			</p>
			<h3>Subscriptions</h3>
			<p>
				Stop worrying about reminding your clients about payments. Simplify your life and have payments automatically withdrawn from clients accounts.
			</p>
			<h3>Packages</h3>
			<p>
				Create fitness or health packages that your client can purchase based on their needs.  Have fitness programs you have designed in the VIP.Coach app automatically assigned when certain packages are purchased.
			</p>
			<h3>Sessions</h3>
			<p>
				Allow clients to purchase blocks of sessions that can easily be tracked and will automatically be deducted when an appointment is scheduled. Or tie sessions to Packages or Subscriptions and track session usage automatically.
			</p>
			<h3>Invoices</h3>
			<p>
				Quickly send client invoices for any type of service you sell.
			</p>
			<h3>Products</h3>
			<p>
				Sell merchandise to your clients as an additional stream of revenue.  From t-shirts to protein powder, sell and track all within the Financials tab.
			</p>
			<h3>Use an Integrated Payment Solution</h3>
			<p>
				No more tracking payments on one platform and workout sessions on a separate one. Everything can be integrated into VIP.Coach along with automation to save you time everywhere from account creation to session tracking.
			</p>
		</div>
	)
}

export default BeginAcceptingPayments